/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking } from "../../clients/individualPaymentTraceabilityController/getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryKey =
  (
    financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams["financialPersonId"],
    params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/order-tracking",
        params: { financialPersonId: financialPersonId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryKey
  >;

export function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryOptions(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryKey(
      financialPersonId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500
    >,
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
    typeof queryKey
  >({
    enabled: !!financialPersonId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking(
        financialPersonId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os logs de pedido (GA_FINANCIAL_ORDER_LOG) do plano com o tipo por extenso, mais recentes primeiro. O legado usava a mesma consulta da parcela. Migrado do legado IndividualPayment/LoadFinancialPersonOrderTrackingGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna o rastreio de pedidos financeiros de um plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/order-tracking}
 */
export function useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking<
  TData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryKey,
>(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryKey(
      financialPersonId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryOptions(
        financialPersonId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
